import { ErrorCode, ErrorCodes } from './errorCodes';

export { ErrorCodes };

export interface AppError {
    statusCode: number;
    errorCode: ErrorCode | 'UNKNOWN_ERROR' | string;
    userMessage: string;
    message?: string; // internal/debug only
}

export function normalizeError(e: unknown): AppError {
    const err = e as Record<string, unknown> | null | undefined;
    const data = (err?.response as Record<string, unknown> | undefined)?.data ?? err ?? {};
    const dataObj = data && typeof data === 'object' && data !== null ? (data as Record<string, unknown>) : {};
    const fault = dataObj.fault && typeof dataObj.fault === 'object' ? (dataObj.fault as Record<string, unknown>) : {};
    const statusCode = Number(dataObj.status ?? fault.status ?? (err?.response as Record<string, unknown> | undefined)?.status ?? 500);

    return {
        statusCode,
        errorCode: String(dataObj.errorCode ?? fault.errorCode ?? (statusCode ? `HTTP_${statusCode}` : 'UNKNOWN_ERROR')),
        userMessage: String(dataObj.userMessage ?? fault.userMessage ?? dataObj.message ?? fault.message ?? 'An unexpected error occurred'),
        message: [dataObj.message, fault.message, err?.message].find((v): v is string => typeof v === 'string' && v !== ''),
    };
}

/** Normalize error from raw response body and status (e.g. in RequestHandler). */
export function extractErrorFromResponse(data: any, status: number): AppError {
    return normalizeError({ response: { data, status } });
}

export function isAppError(e: any): e is AppError {
    return !!e && typeof e.errorCode === 'string' && typeof e.userMessage === 'string';
}

export function isErrorCode(err: unknown, code: ErrorCode): boolean {
    return isAppError(err) && err.errorCode === code;
}

export function getUserMessage(err: unknown, fallback = 'An unexpected error occurred'): string {
    return isAppError(err) ? err.userMessage : fallback;
}
